import type { IAssignFlow, IAssignFlowResult } from './types'

export class SimpleAssignFlow implements IAssignFlow {
  constructor(
    private _getMemberId: () => number | null,
    private _addMembersToExistingInbox: (memberId: number, inboxIds: number[]) => Promise<boolean>
  ) {}

  shouldIncludeMemberInNewInbox = (): boolean => true

  handleExistingInboxAssign = async (inboxIds: number[]): Promise<IAssignFlowResult> => {
    const memberId = this._getMemberId()
    if (!memberId) return { success: false }

    const success = await this._addMembersToExistingInbox(memberId, inboxIds)
    return { success }
  }

  handleNewInboxCreated = async (): Promise<IAssignFlowResult> => {
    return { success: true }
  }

  getExistingInboxSuccessToast = (inboxCount: number): string => {
    return inboxCount > 1 ? `Assigned to ${inboxCount} inboxes` : 'Assigned to inbox'
  }

  getNewInboxSuccessToast = (inboxName: string): string => {
    return `Assigned to ${inboxName} inbox`
  }
}
